module.exports = __webpack_public_path__ + "media/images/articles/resume/thumb-33f30581e337869dd4e77216001cd765.png";